import * as amplitude from "@amplitude/analytics-browser";
import type { AnalyticsApp } from "./";

export default function amplitudePlugin(_config: { apiKey: string; app: AnalyticsApp }) {
  let amplitudeInitCompleted = false;

  const defaultProperties = {
    app: _config.app,
  };

  return {
    name: "amplitude-plugin",
    config: {
      apiKey: _config.apiKey,
      app: _config.app,
    },
    initialize: ({ config }: { config: { apiKey: string } }) => {
      amplitude.init(config.apiKey, {
        serverZone: "EU",
        defaultTracking: {
          pageViews: false,
        },
      });

      amplitudeInitCompleted = true;
    },
    page: ({ payload }: { payload: { properties: Record<string, unknown> } }) => {
      amplitude.track("Page Viewed", {
        ...defaultProperties,
        ...payload.properties,
      });
    },
    track: async ({ payload }: { payload: { event: string; properties: Record<string, unknown> } }) => {
      const response = await amplitude.track(payload.event, {
        ...defaultProperties,
        ...payload.properties,
      }).promise;

      // Optionally check response status
      if (response.code !== 200) {
        console.warn("Amplitude tracking failed:", response);
      }
      return response;
    },
    identify: ({
      payload,
    }: {
      payload: {
        traits: {
          email?: string;
          firstName?: string;
          lastName?: string;
        };
        userId: string;
      };
    }) => {
      const event = new amplitude.Identify();
      amplitude.setUserId(payload.userId);

      event.set("app", _config.app);

      Object.entries(payload.traits).forEach(([key, value]) => {
        event.set(key, value);
      });

      amplitude.identify(event);
    },
    loaded: () => amplitudeInitCompleted,
  };
}
